import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBoxWithoutLoading from "@/components/SkeletonBoxWithoutLoading.vue";
import cashbackPolicyApi from "@/api/common/cashbackPolicyApi.js";

export default {
    components: {
        DetailView: lazyLoadComponent({
            componentFactory: () => import("@/views/spentCashback/DetailView.vue"),
            loading: SkeletonBoxWithoutLoading,
        }),
    },
    data() {
        return {
            policyData: {},
            loading: false,
        }
    },
    created() {
        this.loadPolicyDetail();
    },
    watch: {
        '$route.params.id': {
            handler: 'loadPolicyDetail',
            immediate: true
        }
    },
    methods: {
        async loadPolicyDetail() {
            const policyId = this.$route.params.id;
            if (!policyId) {
                this.policyData = {};
                return;
            }

            try {
                this.loading = true;
                const response = await cashbackPolicyApi.detailPolicy(policyId);
                
                if (response.data && response.data.result === 0) {
                    this.policyData = response.data.data || {};
                } else {
                    this.policyData = {};
                    console.error('API Error:', response.data);
                    if (this.$message) {
                        this.$message.error('Failed to load policy detail');
                    }
                }
            } catch (error) {
                console.error('Error loading policy detail:', error);
                this.policyData = {};
                if (this.$message && !error.message.includes('timeout') && !error.message.includes('Network Error')) {
                    this.$message.error('Error loading policy detail: ' + error.message);
                }
            } finally {
                this.loading = false;
            }
        },

        goBack() {
            this.$router.push('/spent-cashback');
        }
    }
}